import React, { useEffect, createElement } from 'react';
import Home from './pages/Home';
export function App() {
  useEffect(() => {
    // Page title
    document.title = 'Mas Claror — Un espacio para parar, respirar y volver a ti';
    const setMeta = (selector: string, attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.querySelector(selector) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('meta[name="description"]', 'name', 'description', 'Masía del siglo XVII en el Lluçanès, Cataluña. Retiros y espacios de desconexión a hora y media de Barcelona.');
    setMeta('meta[property="og:title"]', 'property', 'og:title', 'Mas Claror');
    setMeta('meta[property="og:description"]', 'property', 'og:description', 'Masía del siglo XVII en el Lluçanès, Cataluña');
    setMeta('meta[property="og:url"]', 'property', 'og:url', 'https://masclaror.com');
  }, []);
  return <Home data-id="element-0" />;
}